import Vue from "vue";
import { GetFlowListURL } from "@/utils/apiUrls";
import quiz from "./quiz";

export default {
  namespaced: true,

  modules: {
    quiz,
  },

  state: {
    isFlowsListLoading: true,
    list: [],
  },

  mutations: {
    setFlowsListLoading(state, payload) {
      state.isFlowsListLoading = payload;
    },

    updateFlowsList: (state, payload) => {
      state.list = payload;
    },
  },

  getters: {
    freeCompany(state) {
      return state.list.find((f) => f.flow.alias === "company_free") || null;
    },

    freeCase(state) {
      return state.list.find((f) => f.flow.alias === "case_free") || null;
    },
  },

  actions: {
    openQuiz({ state, dispatch }, payload) {
      // console.log(payload, state.list)
      if (payload.alias) {
        const userflows = state.list.filter(
          (uf) => uf.flow.alias == payload.alias
        );
        if (userflows.length == 1)
          dispatch("quiz/selectUserflowForQuiz", { userflow: userflows[0] });
      }
    },

    async refreshFlowsList({ commit }) {
      commit("setFlowsListLoading", true);
      await Vue.axios
        .get(GetFlowListURL)
        .then((resp) => {
          commit("updateFlowsList", resp.data);
          commit("setFlowsListLoading", false);
        })
        .catch(console.error); // @TODO Logout?
    },
  },
};
